import { cn } from '@/lib/utils';
import type { RAGStatus } from '@/data/types';

export type PillVariant =
    | 'green'
    | 'amber'
    | 'red'
    | 'blue'
    | 'indigo'
    | 'grey'
    | 'purple'
    | 'teal';
export type PillSize = 'sm' | 'md';

export function ragToPillVariant(rag: RAGStatus): PillVariant {
    switch (rag) {
        case 'Green':
            return 'green';
        case 'Amber':
            return 'amber';
        case 'Red':
            return 'red';
    }
}

// Variant → tokenised badge class. The badge classes are rebuilt onto rag /
// accent / persona tokens in globals.css (.septima-badge--*), so dark mode
// themes correctly.
//
// Alias mapping (kept as prop values for back-compat, but collapsed to three
// real swatches):
//   indigo, purple → violet  (persona-comply token)
//   teal           → blue     (accent token)
// New code should prefer the canonical green/amber/red/blue/violet/grey.
const variantClasses: Record<PillVariant, string> = {
    green: 'septima-badge--green',
    amber: 'septima-badge--amber',
    red: 'septima-badge--red',
    blue: 'septima-badge--blue',
    indigo: 'septima-badge--violet',
    grey: 'septima-badge--neutral',
    purple: 'septima-badge--violet',
    teal: 'septima-badge--blue',
};

const sizeClasses: Record<PillSize, string> = {
    sm: 'h-[22px] px-[9px]',
    md: 'h-6 px-[10px]',
};

interface PillProps {
    variant: PillVariant;
    label: string;
    size?: PillSize;
    className?: string;
}

export default function Pill({ variant, label, size = 'md', className }: PillProps) {
    return (
        <span
            className={cn(
                'septima-badge max-w-full',
                sizeClasses[size],
                variantClasses[variant],
                className,
            )}
            title={label}
        >
            <span className="truncate">{label}</span>
        </span>
    );
}
